export const GET_ASSET_HISTORY = 'GET_ASSET_HISTORY'
export const GET_ASSET_HISTORY_PENDING = 'GET_ASSET_HISTORY_PENDING'
export const GET_ASSET_HISTORY_FULFILLED = 'GET_ASSET_HISTORY_FULFILLED'
export const GET_ASSET_HISTORY_REJECTED = 'GET_ASSET_HISTORY_REJECTED'
